import { ColumnConfig } from "components/Table/types";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { ApiKey, SearchQueryOrderDirection } from "types/generated";

export enum API_KEYS_COLUMN_ID {
  NAME = "NAME",
  ID = "ID",
  TYPE = "TYPE",
  GROUPS = "GROUPS",
  CREATOR = "CREATOR",
  CREATED_AT = "CREATED_AT",
  EXPIRES_AT = "EXPIRES_AT",
  LAST_USED = "LAST_USED",
  DROPDOWN = "DROPDOWN",
}

export const API_KEYS_COLUMNS_STORAGE_KEY = "apiKeysColumnsConfig";
export const API_KEYS_FILTERS_ORDER_SETTINGS_KEY = "apiKeysFiltersOrder";

export const initialSortOption = "lastUsedAt";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export const ROW_HEADER_ID = API_KEYS_COLUMN_ID.NAME;

const MAX_CELL_WIDTH = 600;

export const API_KEYS_COLUMN_CONFIG: ColumnConfig = {
  [API_KEYS_COLUMN_ID.NAME]: {
    title: "Name",
    minWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },

  [API_KEYS_COLUMN_ID.ID]: {
    title: "Key ID",
    minWidth: 290,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },

  [API_KEYS_COLUMN_ID.TYPE]: {
    title: "Type",
    minWidth: 80,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },

  [API_KEYS_COLUMN_ID.GROUPS]: {
    title: "Groups",
    minWidth: 100,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },

  [API_KEYS_COLUMN_ID.CREATOR]: {
    title: "Creator",
    minWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },

  [API_KEYS_COLUMN_ID.CREATED_AT]: {
    title: "Created at",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },

  [API_KEYS_COLUMN_ID.EXPIRES_AT]: {
    title: "Expires on",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },

  [API_KEYS_COLUMN_ID.LAST_USED]: {
    title: "Last used",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: true,
  },
};

export const API_KEYS_CUSTOM_END_COLUMN_CONFIG: ColumnConfig = {
  [API_KEYS_COLUMN_ID.DROPDOWN]: {
    title: "More actions",
    noHeader: true,
    static: true,
    maxWidth: 60,
    minWidth: 60,
    width: 60,
    sticky: true,
    resizable: false,
  },
};

export type API_KEYS_SORT_KEYS = Exclude<API_KEYS_COLUMN_ID, API_KEYS_COLUMN_ID.DROPDOWN>;

export const SORT_CONFIG: Record<API_KEYS_SORT_KEYS, keyof ApiKey> = {
  [API_KEYS_COLUMN_ID.NAME]: "name",
  [API_KEYS_COLUMN_ID.ID]: "id",
  [API_KEYS_COLUMN_ID.TYPE]: "type",
  [API_KEYS_COLUMN_ID.GROUPS]: "teamCount",
  [API_KEYS_COLUMN_ID.CREATOR]: "creator",
  [API_KEYS_COLUMN_ID.CREATED_AT]: "createdAt",
  [API_KEYS_COLUMN_ID.LAST_USED]: "lastUsedAt",
  [API_KEYS_COLUMN_ID.EXPIRES_AT]: "expiresAt",
};

export const INITIAL_COLUMNS_VIEW_CONFIG = {
  visible: Object.keys(API_KEYS_COLUMN_CONFIG) as API_KEYS_COLUMN_ID[],
  hidden: [],
};

export const ANALYTICS = {
  analyticsPage: AnalyticsPageOrganization.OrganizationApiKeys,
};
